import { StreamingPlayerImage } from '@heardis/stream-contracts';
import Image from '../Image';
import classes from './BackgroundImage.module.css';

type BackgroundImageProps = {
  zIndex: number;
} & StreamingPlayerImage;

function BackgroundImage({ url, alt, blur, position, fit, zIndex }: BackgroundImageProps) {
  return (
    <picture className={classes.backgroundImageContainer} style={{ zIndex }}>
      <Image url={url} alt={alt} blur={blur} position={position} fit={fit} height="100%" width="100%" />
    </picture>
  );
}

export default BackgroundImage;
